<template>
  <div class="page-wrap">
    <div class="page-head">
      <div class="breadcrumbs">
        <div class="h1">
          <router-link class="link-not-like" to="/garage/">{{ $vuetify.lang.t('$vuetify.menu.garage') }}
          </router-link>
        </div>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ currentCar.name }}
        </div>
      </div>
    </div>

    <div class="profile garage">
      <div class="profile-main cards__single">
        <div class="profile-main__header object-header">
          <div class="profile-main__photos garage-main__photos">
            <v-carousel v-model="slider" height="300"
                        :cycle="false"
                        :hide-delimiters="false"
                        hide-delimiter-background>
              <v-carousel-item
                  v-for="ph in currentCar.photo"
                  :key="ph"
                  transition="fade-transition"
              >
                <img class="slide-photo" :src="$media_url + ph" alt="photo">
              </v-carousel-item>
            </v-carousel>
          </div>
          <div class="profile-main__name h2">
            {{ currentCar.name }}
          </div>
          <div class="profile-main__post">
            {{ currentCar.type_body }}
          </div>
        </div>

        <div class="profile-main__options">
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <calendar-icon/>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.regDate') }}</div>
            <div class="profile-main__option-val">
              {{ new Date(currentCar.registration).toLocaleDateString('ru-Ru') }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
                <path
                    style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal"
                    d="M 23.857422 2 C 22.749479 2 22 2.9821212 22 4 L 22 7.9902344 L 14.068359 7.9902344 C 11.832946 7.9902344 10 9.8242551 10 12.058594 L 10 43.921875 C 10 46.157288 11.834021 47.990234 14.068359 47.990234 L 37.921875 47.990234 C 40.157288 47.990234 41.990234 46.156213 41.990234 43.921875 L 41.990234 12.060547 L 41.990234 12.058594 C 41.990464 9.8237651 40.157503 7.9902344 37.923828 7.9902344 L 30 7.9902344 L 30 4 C 30 2.9821212 29.250521 2 28.142578 2 L 23.857422 2 z M 24 4 L 28 4 L 28 12 L 24 12 L 24 8.9902344 L 24 4 z M 14.068359 9.9902344 L 22 9.9902344 L 22 12 C 22 13.017879 22.749479 14 23.857422 14 L 28.142578 14 C 29.250521 14 30 13.017879 30 12 L 30 9.9902344 L 37.923828 9.9902344 C 39.07749 9.9902344 39.990915 10.904325 39.990234 12.058594 L 39.990234 43.921875 C 39.990234 45.075537 39.076462 45.990234 37.921875 45.990234 L 14.068359 45.990234 C 12.914698 45.990234 12 45.076462 12 43.921875 L 12 12.058594 C 12 10.904932 12.913772 9.9902344 14.068359 9.9902344 z M 23 17 C 22.348333 17 21.747335 17.14149 21.234375 17.40625 C 20.721415 17.67101 20.257242 18.063884 20.050781 18.685547 L 19 21.837891 L 19 22 L 18 22 L 18 24 L 19 24 L 19 28.667969 L 19 29.332031 C 19 29.700031 19.224 30 19.5 30 L 21.5 30 C 21.776 30 22 29.700031 22 29.332031 L 22 28.667969 L 30 28.667969 L 30 29.332031 C 30 29.700031 30.224 30 30.5 30 L 32.5 30 C 32.776 30 33 29.700031 33 29.332031 L 33 27.332031 L 33 24 L 34 24 L 34 22 L 33 22 L 33 21.837891 L 31.949219 18.685547 C 31.742758 18.063884 31.278585 17.67101 30.765625 17.40625 C 30.252665 17.14149 29.651667 17 29 17 L 23 17 z M 23 19 L 29 19 C 29.348333 19 29.655867 19.0846 29.847656 19.183594 C 30.028133 19.276744 30.069478 19.372531 30.052734 19.320312 L 30.945312 22 L 21.054688 22 L 21.947266 19.320312 C 21.930522 19.372529 21.971863 19.276744 22.152344 19.183594 C 22.344133 19.08465 22.651667 19 23 19 z M 22 24 C 22.552 24 23 24.448 23 25 C 23 25.552 22.552 26 22 26 C 21.448 26 21 25.552 21 25 C 21 24.448 21.448 24 22 24 z M 30 24 C 30.552 24 31 24.448 31 25 C 31 25.552 30.552 26 30 26 C 29.448 26 29 25.552 29 25 C 29 24.448 29.448 24 30 24 z M 17 34 A 1.0001 1.0001 0 1 0 17 36 L 35 36 A 1.0001 1.0001 0 1 0 35 34 L 17 34 z M 17 38 A 1.0001 1.0001 0 1 0 17 40 L 35 40 A 1.0001 1.0001 0 1 0 35 38 L 17 38 z"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.regNumber') }}</div>

            <div class="profile-main__option-val">
              {{ currentCar.reg_number }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
                <path
                    style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal"
                    d="M 23.857422 2 C 22.749479 2 22 2.9821212 22 4 L 22 7.9902344 L 14.068359 7.9902344 C 11.832946 7.9902344 10 9.8242551 10 12.058594 L 10 43.921875 C 10 46.157288 11.834021 47.990234 14.068359 47.990234 L 37.921875 47.990234 C 40.157288 47.990234 41.990234 46.156213 41.990234 43.921875 L 41.990234 12.060547 L 41.990234 12.058594 C 41.990464 9.8237651 40.157503 7.9902344 37.923828 7.9902344 L 30 7.9902344 L 30 4 C 30 2.9821212 29.250521 2 28.142578 2 L 23.857422 2 z M 24 4 L 28 4 L 28 12 L 24 12 L 24 8.9902344 L 24 4 z M 14.068359 9.9902344 L 22 9.9902344 L 22 12 C 22 13.017879 22.749479 14 23.857422 14 L 28.142578 14 C 29.250521 14 30 13.017879 30 12 L 30 9.9902344 L 37.923828 9.9902344 C 39.07749 9.9902344 39.990915 10.904325 39.990234 12.058594 L 39.990234 43.921875 C 39.990234 45.075537 39.076462 45.990234 37.921875 45.990234 L 14.068359 45.990234 C 12.914698 45.990234 12 45.076462 12 43.921875 L 12 12.058594 C 12 10.904932 12.913772 9.9902344 14.068359 9.9902344 z M 23 17 C 22.348333 17 21.747335 17.14149 21.234375 17.40625 C 20.721415 17.67101 20.257242 18.063884 20.050781 18.685547 L 19 21.837891 L 19 22 L 18 22 L 18 24 L 19 24 L 19 28.667969 L 19 29.332031 C 19 29.700031 19.224 30 19.5 30 L 21.5 30 C 21.776 30 22 29.700031 22 29.332031 L 22 28.667969 L 30 28.667969 L 30 29.332031 C 30 29.700031 30.224 30 30.5 30 L 32.5 30 C 32.776 30 33 29.700031 33 29.332031 L 33 27.332031 L 33 24 L 34 24 L 34 22 L 33 22 L 33 21.837891 L 31.949219 18.685547 C 31.742758 18.063884 31.278585 17.67101 30.765625 17.40625 C 30.252665 17.14149 29.651667 17 29 17 L 23 17 z M 23 19 L 29 19 C 29.348333 19 29.655867 19.0846 29.847656 19.183594 C 30.028133 19.276744 30.069478 19.372531 30.052734 19.320312 L 30.945312 22 L 21.054688 22 L 21.947266 19.320312 C 21.930522 19.372529 21.971863 19.276744 22.152344 19.183594 C 22.344133 19.08465 22.651667 19 23 19 z M 22 24 C 22.552 24 23 24.448 23 25 C 23 25.552 22.552 26 22 26 C 21.448 26 21 25.552 21 25 C 21 24.448 21.448 24 22 24 z M 30 24 C 30.552 24 31 24.448 31 25 C 31 25.552 30.552 26 30 26 C 29.448 26 29 25.552 29 25 C 29 24.448 29.448 24 30 24 z M 17 34 A 1.0001 1.0001 0 1 0 17 36 L 35 36 A 1.0001 1.0001 0 1 0 35 34 L 17 34 z M 17 38 A 1.0001 1.0001 0 1 0 17 40 L 35 40 A 1.0001 1.0001 0 1 0 35 38 L 17 38 z"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.vin') }}</div>

            <div class="profile-main__option-val">
              {{ currentCar.vin }}
            </div>
          </div>
          <div class="profile-main__option">
            <div class="profile-main__option-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 50">
                <path
                    style="line-height:normal;text-indent:0;text-align:start;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000;text-transform:none;block-progression:tb;isolation:auto;mix-blend-mode:normal"
                    d="M 23.857422 2 C 22.749479 2 22 2.9821212 22 4 L 22 7.9902344 L 14.068359 7.9902344 C 11.832946 7.9902344 10 9.8242551 10 12.058594 L 10 43.921875 C 10 46.157288 11.834021 47.990234 14.068359 47.990234 L 37.921875 47.990234 C 40.157288 47.990234 41.990234 46.156213 41.990234 43.921875 L 41.990234 12.060547 L 41.990234 12.058594 C 41.990464 9.8237651 40.157503 7.9902344 37.923828 7.9902344 L 30 7.9902344 L 30 4 C 30 2.9821212 29.250521 2 28.142578 2 L 23.857422 2 z M 24 4 L 28 4 L 28 12 L 24 12 L 24 8.9902344 L 24 4 z M 14.068359 9.9902344 L 22 9.9902344 L 22 12 C 22 13.017879 22.749479 14 23.857422 14 L 28.142578 14 C 29.250521 14 30 13.017879 30 12 L 30 9.9902344 L 37.923828 9.9902344 C 39.07749 9.9902344 39.990915 10.904325 39.990234 12.058594 L 39.990234 43.921875 C 39.990234 45.075537 39.076462 45.990234 37.921875 45.990234 L 14.068359 45.990234 C 12.914698 45.990234 12 45.076462 12 43.921875 L 12 12.058594 C 12 10.904932 12.913772 9.9902344 14.068359 9.9902344 z M 23 17 C 22.348333 17 21.747335 17.14149 21.234375 17.40625 C 20.721415 17.67101 20.257242 18.063884 20.050781 18.685547 L 19 21.837891 L 19 22 L 18 22 L 18 24 L 19 24 L 19 28.667969 L 19 29.332031 C 19 29.700031 19.224 30 19.5 30 L 21.5 30 C 21.776 30 22 29.700031 22 29.332031 L 22 28.667969 L 30 28.667969 L 30 29.332031 C 30 29.700031 30.224 30 30.5 30 L 32.5 30 C 32.776 30 33 29.700031 33 29.332031 L 33 27.332031 L 33 24 L 34 24 L 34 22 L 33 22 L 33 21.837891 L 31.949219 18.685547 C 31.742758 18.063884 31.278585 17.67101 30.765625 17.40625 C 30.252665 17.14149 29.651667 17 29 17 L 23 17 z M 23 19 L 29 19 C 29.348333 19 29.655867 19.0846 29.847656 19.183594 C 30.028133 19.276744 30.069478 19.372531 30.052734 19.320312 L 30.945312 22 L 21.054688 22 L 21.947266 19.320312 C 21.930522 19.372529 21.971863 19.276744 22.152344 19.183594 C 22.344133 19.08465 22.651667 19 23 19 z M 22 24 C 22.552 24 23 24.448 23 25 C 23 25.552 22.552 26 22 26 C 21.448 26 21 25.552 21 25 C 21 24.448 21.448 24 22 24 z M 30 24 C 30.552 24 31 24.448 31 25 C 31 25.552 30.552 26 30 26 C 29.448 26 29 25.552 29 25 C 29 24.448 29.448 24 30 24 z M 17 34 A 1.0001 1.0001 0 1 0 17 36 L 35 36 A 1.0001 1.0001 0 1 0 35 34 L 17 34 z M 17 38 A 1.0001 1.0001 0 1 0 17 40 L 35 40 A 1.0001 1.0001 0 1 0 35 38 L 17 38 z"/>
              </svg>
            </div>
            <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.accounting.card.price') }}</div>

            <div class="profile-main__option-val">
              {{ currentCar.cost }} <span v-if="currentCar.cost"> €</span>
            </div>
          </div>
        </div>
      </div>
      <div class="profile-tabs cards__single">
        <div class="profile-tabs__head">
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 1 }" @click="tab_selected = 1">
            {{ $vuetify.lang.t('$vuetify.mainInfo') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 2 }" @click="tab_selected = 2">
            {{ $vuetify.lang.t('$vuetify.comments') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 3 }" @click="tab_selected = 3">
            {{ $vuetify.lang.t('$vuetify.maintenanceReports') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 6 }" @click="tab_selected = 6">
            {{ $vuetify.lang.t('$vuetify.carDocuments') }}
          </div>
        </div>
        <div class="profile-tabs__content">
          <div v-if="tab_selected === 1" class="profile-tabs__content-item">
            <div class="characteristics">

              <div class="characteristics__list">
                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.color') }}</div>
                  <div class="characteristics__val">
                    {{ currentCar.color }}
                  </div>
                </div>
                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.odometer') }}</div>
                  <div class="characteristics__val">
                    {{ currentCar.odometer }}
                  </div>
                </div>
              </div>

              <div class="characteristics__list">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.carTechnic') }}</div>

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.engine') }}</div>
                  <div class="characteristics__val">
                    {{ currentCar.engine }}
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.fuel') }}</div>
                  <div class="characteristics__val">
                    {{ currentCar.fuel }}
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.typeDrive') }}
                  </div>
                  <div class="characteristics__val">
                    {{ currentCar.type_drive }}
                  </div>
                </div>
                <div class="characteristics__item">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.transmission') }}
                  </div>
                  <div class="characteristics__val">
                    {{ currentCar.transmission }}
                  </div>
                </div>
              </div>


              <div class="characteristics__list">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.characteristics') }}</div>
                <div class="characteristics__item">
                  <div class="characteristics__val">
                    <pre>{{ currentCar.characteristics }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 2" class="profile-tabs__content-item">
            <CommentList
                table="garage"
                :id="id"
            />
          </div>
          <div v-if="tab_selected === 3" class="profile-tabs__content-item">
            <div class="documents">
              <div class="page-head page-head--sorts">
                <div class="page__sorts">
                  <button class="btn btn-secondary mt-20 mb-40" @click="openMaintenanceModal()">
                    + {{ $vuetify.lang.t('$vuetify.addDocument') }}
                  </button>
                </div>
                <div class="page-head--right">
                  <per-page-select v-model="perPage"></per-page-select>
                  <div class="type-switcher">
                    <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
                        <path
                            d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                            fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                              fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <BaseTable :type="type" :draggable_mode="false"
                         :headers="headersMaintenance" :show-headers="showHeadersMaintenance"
                         :sort="sort"
              >
                <template #cards="{ type,  headers, showHeaders }">
                  <BaseCard v-for="m in maintenance" :key="m.id" :type="type" :headers="headers"
                            :show-headers="showHeaders" :cp="true"
                            :title="m.title" :photo="m.preview" :card="m" :options="m.options"
                            :show-archive="false" :show-load="false"
                            @open="showMaintenance(m)"
                            @edit="openMaintenanceModal(m)"
                            @delete="confirmMaintenance(m)"
                  />
                </template>
              </BaseTable>
              <div class="page-footer">
                <button class="btn-secondary btn" @click="all" style="margin-right: 10px">
                  <span>{{ $vuetify.lang.t('$vuetify.main.see_all') }}</span>
                </button>
                <per-page-select v-model="perPage"></per-page-select>
                <v-pagination
                    v-model="page"
                    :length="length"
                    @input="loadMaintenance"
                ></v-pagination>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 6" class="profile-tabs__content-item">
            <div class="documents">
              <div class="page__sorts">
                <button class="btn btn-secondary mt-20 mb-40"
                        v-if="permissions.edit.indexOf('Гараж') !== -1"
                        @click="addDocumentModal = true; newDocument.garage_id = id">
                  + {{ $vuetify.lang.t('$vuetify.addDocument') }}
                </button>
                <div class="documents__sorts">
                  <div class="sorts__radio">
                    <span>{{ $vuetify.lang.t('$vuetify.dataTable.sortBy') }}</span>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="name" id="sort9"
                             class="custom-radio__hide"/>
                      <label for="sort9" class="custom-radio__button"><span></span></label>
                      <label for="sort9">{{ $vuetify.lang.t('$vuetify.sorts.byName') }}</label>
                    </div>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="create_date" id="sort7"
                             class="custom-radio__hide"/>
                      <label for="sort7" class="custom-radio__button"><span></span></label>
                      <label for="sort7">{{ $vuetify.lang.t('$vuetify.sorts.byCreateDate') }}</label>
                    </div>
                  </div>
                  <v-select class="sorts__select" v-model="sort"
                            :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                            :items="selectSorts" item-text="name" item-value="value"
                            :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: 200,
                                      contentClass: 'select-menu',
                                  }"
                            outlined hide-details attach></v-select>
                </div>

                <div class="page-head--right">
                  <div class="type-switcher">
                    <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
                        <path
                            d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                            fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                              fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <BaseTable :headers="headersDocuments" :type="type" :draggable_mode="false"
                         :show-headers="showHeadersDocuments" :sort="sort"
              >
                <template #cards="{ type,  headers, showHeaders }">
                  <BaseCard v-for="doc in currentCar.documents" :key="doc.id" :type="type" :headers="headers"
                            :show-headers="showHeaders" :cp="true"
                            :title="doc.name" :photo="doc.path" :card="doc" :options="doc.options"
                            :show-archive="false"
                            :show-edit="permissions.edit.indexOf('Гараж') !== -1"
                            :show-delete="permissions.edit.indexOf('Гараж') !== -1"
                            @edit="newDocument = doc; addDocumentModal = true;"
                            @delete="confirm_document_open(doc.id)"
                            @open="lightboxItems = []; lightboxItems.push($hostname + 'time-tracking/preview/' + doc.path); index=0"
                            @open-photo="lightboxItems = []; lightboxItems.push($hostname + 'time-tracking/preview/' +  doc.path); index=0"
                            @download-document="downloadDocument(doc)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>
        </div>
      </div>
    </div>


    <ConfirmModal v-model="confirm_document_modal" @confirm="deleteDocument">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <ConfirmModal v-model="confirmMaintenanceModal" @confirm="deleteMaintenance">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>
    <v-dialog v-model="addDocumentModal">
      <div class="modal modal-big">
        <v-form ref="documentForm" @submit.prevent="">
          <v-text-field v-model="newDocument.name"
                        :label="$vuetify.lang.t('$vuetify.accounting.card.name')" outlined></v-text-field>
          <v-file-input v-if="!newDocument.id" accept=".jpg, .png, .pdf, .doc, .docx" class="file-input"
                        v-model="newDocument.file"
                        :placeholder="$vuetify.lang.t('$vuetify.downloadDocument')" prepend-icon="$document"
                        :rules="[$rules.required, $rules.fileSize]">
          </v-file-input>
          <v-file-input v-else accept=".jpg, .png, .pdf, .doc, .docx" class="file-input" v-model="newDocument.file"
                        :placeholder="$vuetify.lang.t('$vuetify.changeDocument')" prepend-icon="$document"
                        :rules="[$rules.fileSize]">
          </v-file-input>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div v-if="alertError" class="error--text">{{ alertMsg }}</div>
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cancelAddDocument">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="uploadDocumentFiles">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>
    <v-dialog v-model="addMaintenanceModal">
      <div class="modal modal-big">
        <v-form ref="maintenanceForm" @submit.prevent="">
          <v-text-field v-model="newMaintenance.title" :label="$vuetify.lang.t('$vuetify.name2')"
                        outlined :rules="[$rules.required]"></v-text-field>
          <div class="form__row">
            <v-menu ref="dateStartMenu" v-model="menus.dateStartMenu"
                    :close-on-content-click="false" transition="scale-transition" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="newMaintenance.start_date ? new Date(newMaintenance.start_date).toLocaleDateString('ru-Ru') : ''"
                    :label="$vuetify.lang.t('$vuetify.accounting.card.time_start')" readonly
                    v-bind="attrs"
                    v-on="on" outlined :rules="[$rules.required]"></v-text-field>
              </template>
              <v-date-picker v-model="newMaintenance.start_date" @input="menus.dateStartMenu = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months></v-date-picker>
            </v-menu>
            <v-menu ref="dateEndMenu" v-model="menus.dateEndMenu"
                    :close-on-content-click="false" transition="scale-transition" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="newMaintenance.end_date ? new Date(newMaintenance.end_date).toLocaleDateString('ru-Ru') : ''"
                    :label="$vuetify.lang.t('$vuetify.accounting.card.time_end')" readonly
                    v-bind="attrs" v-on="on" outlined></v-text-field>
              </template>
              <v-date-picker v-model="newMaintenance.end_date" @input="menus.dateEndMenu = false"
                             no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                             show-adjacent-months :min="newMaintenance.start_date"></v-date-picker>
            </v-menu>
          </div>

          <v-text-field v-model="newMaintenance.service_type" :label="$vuetify.lang.t('$vuetify.maintenanceType')"
                        outlined></v-text-field>
          <v-menu ref="nextDateMenu" v-model="menus.nextDateMenu"
                  :close-on-content-click="false" transition="scale-transition" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="newMaintenance.next_service_date ? new Date(newMaintenance.next_service_date).toLocaleDateString('ru-Ru') : ''"
                  :label="$vuetify.lang.t('$vuetify.nextServiceDate')" readonly
                  v-bind="attrs" v-on="on" outlined></v-text-field>
            </template>
            <v-date-picker v-model="newMaintenance.next_service_date" @input="menus.nextDateMenu = false"
                           no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                           show-adjacent-months :min="newMaintenance.start_date"></v-date-picker>
          </v-menu>

          <v-text-field :label="$vuetify.lang.t('$vuetify.odometer')" v-model="newMaintenance.odometer" outlined>
          </v-text-field>

          <v-divider class="mb-4"></v-divider>

          <div>
            <div class="d-flex align-center justify-space-between mb-4">
              <h3 class="subtitle-1">{{ $vuetify.lang.t("$vuetify.worksAndMaterials") }}</h3>
              <v-btn text small @click="addWorkItem">{{ $vuetify.lang.t("$vuetify.add") }}</v-btn>
            </div>
            <div v-for="(item, i) in newMaintenance.local_work_items" :key="i">
              <div class="d-flex align-baseline">
                <v-select v-model="item.type"
                          :items="maintenanceTypes"
                          label="Тип" outlined class="mr-2"
                          :rules="[$rules.required]"></v-select>

                <v-icon small @click="removeWorkItem(i)">mdi-delete</v-icon>
              </div>
              <div class="form__row">
                <v-text-field v-model="item.code"
                              :label="$vuetify.lang.t('$vuetify.code')" outlined class="mr-2"></v-text-field>
                <v-text-field v-model="item.description" :label="$vuetify.lang.t('$vuetify.description')" outlined
                              class="flex-grow-1 mr-2" :rules="[$rules.required]"
                ></v-text-field>
              </div>
              <div class="form__row">
                <v-text-field type="number" v-model="item.quantity"
                              :label="$vuetify.lang.t('$vuetify.wages.quantity')"
                              outlined></v-text-field>
                <v-combobox class="custom" v-model="item.unit" clearable
                            :value="$vuetify.lang.t('$vuetify.measurements.' + item.measurement) ? $vuetify.lang.t('$vuetify.measurements.' + item.measurement) : item.measurement"
                            :label="$vuetify.lang.t('$vuetify.wages.measurement')"
                            :items="measurements" item-text="name" item-value="value" outlined attach
                            :menu-props="{
                          bottom: true,
                          offsetY: true,
                          maxHeight: width<1024 ? 200 : 800,
                          contentClass: 'select-menu',
                        }">
                  <template v-slot:item="{ item }">
                    {{
                      $vuetify.lang.t('$vuetify.measurements.' + item) ? $vuetify.lang.t('$vuetify.measurements.' + item) : item
                    }}
                  </template>
                  <template v-slot:selection="{ item }">
                  <span>{{
                      $vuetify.lang.t('$vuetify.measurements.' + item) ? $vuetify.lang.t('$vuetify.measurements.' + item) : item
                    }}</span>
                  </template>
                </v-combobox>
                <v-text-field v-model="item.discount" type="number"
                              :label="$vuetify.lang.t('$vuetify.accounting.card.discount')" outlined></v-text-field>
              </div>
              <div class="form__row">
                <v-select v-model="item.tax" outlined attach
                          :label="$vuetify.lang.t('$vuetify.accounting.card.tax')"
                          :items="taxes" item-text="tax" item-value="id"
                          :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                      maxHeight: width<1024 ? 200 : 800,
                                      contentClass: 'select-menu',
                                  }"
                          :rules="[$rules.required]"
                ></v-select>
                <v-text-field v-model="item.cost_net"
                              :label="$vuetify.lang.t('$vuetify.accounting.card.cost')"
                              type="number" outlined
                              class="mr-2" :rules="[$rules.required, v => v >= 0 || '≥ 0']"></v-text-field>
              </div>
            </div>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="form__row align-baseline">
            <h3 class="subtitle-1">{{ $vuetify.lang.t("$vuetify.accounting.statistic.count") }}</h3>
            <v-text-field v-model="newMaintenance.total_net" type="number" readonly disabled
                          outlined :rules="[$rules.required]">
            </v-text-field>
          </div>

          <v-divider class="my-4"></v-divider>

          <v-file-input v-if="!newMaintenance.id" accept=".jpg, .png, .jpeg" class="file-input"
                        v-model="newMaintenance.photo_file"
                        :placeholder="$vuetify.lang.t('$vuetify.downloadPhoto')" prepend-icon="$document"
                        multiple :rules="[$rules.multipleFileSize]">
          </v-file-input>
          <v-file-input v-else accept=".jpg, .png, .pdf, .doc, .docx" class="file-input"
                        v-model="newMaintenance.photo_file"
                        :placeholder="$vuetify.lang.t('$vuetify.changePhoto')" prepend-icon="$document"
                        multiple :rules="[$rules.multipleFileSize]">
          </v-file-input>
          <div class="flex">
            <div v-for="(doc, i) in newMaintenance.photos" :key="doc.id">
              <button class="btn-icon" @click="removeAttachment(doc.id, 'photo', i)">
                <v-icon>mdi-close</v-icon>
              </button>
              <img class="document-row__photo"
                   v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.file.substr(doc.file.lastIndexOf('.') + 1)))"
                   :src="$media_url + doc.file" alt="photo"/>
              <v-tooltip top v-else :key="doc.id">
                <template v-slot:activator="{ on, attrs }">
                  <img v-bind="attrs" v-on="on" class="document-row__photo"
                       src="../../assets/img/document-preview.svg"
                       alt="">
                </template>
                <span>{{
                    doc.file.substr(doc.file.lastIndexOf('/') + 1, doc.file.lastIndexOf('_') + 1) + doc.file.substr(doc.file.lastIndexOf('.'))
                  }}</span>
              </v-tooltip>
            </div>
          </div>
          <v-file-input v-if="!newMaintenance.id" accept=".jpg, .png, .pdf, .doc, .docx" class="file-input"
                        v-model="newMaintenance.receipt_file"
                        :placeholder="$vuetify.lang.t('$vuetify.receipt')" prepend-icon="$document"
                        multiple :rules="[$rules.multipleFileSize]">
          </v-file-input>
          <v-file-input v-else accept=".jpg, .png, .pdf, .doc, .docx" class="file-input"
                        v-model="newMaintenance.receipt_file"
                        :placeholder="$vuetify.lang.t('$vuetify.receipt')" prepend-icon="$document"
                        multiple :rules="[$rules.multipleFileSize]">
          </v-file-input>
          <div class="flex">
            <div class="do" v-for="(doc, i) in newMaintenance.receipts" :key="doc.id">
              <button class="btn-icon" @click="removeAttachment(doc.id, 'receipt', i)">
                <v-icon>mdi-close</v-icon>
              </button>
              <img class="document-row__photo"
                   v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.file.substr(doc.file.lastIndexOf('.') + 1)))"
                   :src="$media_url + doc.file" alt="photo"/>
              <v-tooltip top v-else :key="doc.id">
                <template v-slot:activator="{ on, attrs }">
                  <img v-bind="attrs" v-on="on" class="document-row__photo"
                       src="../../assets/img/document-preview.svg"
                       alt="">
                </template>
                <span>{{
                    doc.file.substr(doc.file.lastIndexOf('/') + 1, doc.file.lastIndexOf('_') + 1) + doc.file.substr(doc.file.lastIndexOf('.'))
                  }}</span>
              </v-tooltip>
            </div>
          </div>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div v-if="alertError" class="error--text">{{ alertMsg }}</div>
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cancelAddMaintenance">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="uploadMaintenanceDocuments">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <v-dialog v-model="showMaintenanceModal" style="z-index: 6 !important;" fullscreen>
      <div class="modal modal-fullscreen business-card">
        <div class="flex align-baseline justify-between">
          <div class="h1">
            {{ currentMaintenance.title }}
          </div>
          <button class="btn btn-primary" @click.stop="showMaintenanceModal=false">{{
              $vuetify.lang.t("$vuetify.close")
            }}
          </button>
        </div>
        <div class="flex justify-start business-card__images">
          <template v-for="doc in currentMaintenance.photos">
            <img class="cp" :key="doc.id"
                 @click="indexMaintenance=lightboxMaintenanceItems.findIndex((element) => element == ($media_url +doc.file))"
                 v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.file.substr(doc.file.lastIndexOf('.') + 1)))"
                 :src="$media_url + doc.file" alt="photo"/>
            <v-tooltip top v-else :key="doc.id">
              <template v-slot:activator="{ on, attrs }">
                <div class="flex flex-column">
                  <img v-bind="attrs" v-on="on" class="document-row__photo"
                       :src="$hostname + 'time-tracking/preview/' + doc.file"
                       @click="indexMaintenance=lightboxMaintenanceItems.findIndex((element) => element == ($hostname + 'time-tracking/preview/' + doc.file))"
                       alt="">
                  <a :href="$media_url + doc.file"
                     v-bind="attrs"
                     v-on="on"
                     target="_blank"
                  >
                    {{ $vuetify.lang.t("$vuetify.loadDoc") }}
                  </a>
                </div>
              </template>
              <span>{{
                  doc.file.substr(doc.file.lastIndexOf('/') + 1, doc.file.lastIndexOf('_') + 1) + doc.file.substr(doc.file.lastIndexOf('.'))
                }}</span>
            </v-tooltip>
          </template>
          <template v-for="doc in currentMaintenance.receipts">
            <img class="cp" :key="doc.id"
                 @click="indexMaintenance=lightboxMaintenanceItems.findIndex((element) => element == ($media_url +doc.file))"
                 v-if="(['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.file.substr(doc.file.lastIndexOf('.') + 1)))"
                 :src="$media_url + doc.file" alt="photo"/>
            <v-tooltip top v-else :key="doc.id">
              <template v-slot:activator="{ on, attrs }">
                <div class="flex flex-column">
                  <img v-bind="attrs" v-on="on" class="document-row__photo"
                       :src="$hostname + 'time-tracking/preview/' + doc.file"
                       @click="indexMaintenance=lightboxMaintenanceItems.findIndex((element) => element == ($hostname + 'time-tracking/preview/' + doc.file))"
                       alt="">
                  <a :href="$media_url + doc.file"
                     v-bind="attrs"
                     v-on="on"
                     target="_blank"
                  >
                    {{ $vuetify.lang.t("$vuetify.loadDoc") }}
                  </a>
                </div>
              </template>
              <span>{{
                  doc.file.substr(doc.file.lastIndexOf('/') + 1, doc.file.lastIndexOf('_') + 1) + doc.file.substr(doc.file.lastIndexOf('.'))
                }}</span>
            </v-tooltip>
          </template>
        </div>
        <div class="flex">
          <div class="flex">
            <span class="bolder">{{ $vuetify.lang.t('$vuetify.accounting.card.time_start') }}:</span>
            <span>{{ new Date(currentMaintenance.start_date).toLocaleDateString() }}</span>
          </div>
          <template v-if="currentMaintenance.end_date">
            <div class="flex">
              <span class="bolder">{{ $vuetify.lang.t('$vuetify.accounting.card.time_end') }}:</span>
              <span>{{ new Date(currentMaintenance.end_date).toLocaleDateString() }}</span>
            </div>
          </template>
        </div>
        <div class="flex" v-if="currentMaintenance.service_type">
          <div class="flex">
            <span class="bolder">{{ $vuetify.lang.t('$vuetify.maintenanceType') }}:</span>
            <span>{{ currentMaintenance.service_type }}</span>
          </div>
          <template v-if="currentMaintenance.next_service_date">
            <div class="flex">
              <span class="bolder">{{ $vuetify.lang.t('$vuetify.nextServiceDate') }}:</span>
              <span>{{ new Date(currentMaintenance.next_service_date).toLocaleDateString() }}</span>
            </div>
          </template>
        </div>
        <div class=" business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.odometer') }}</span>
          <span>{{ currentMaintenance.odometer }}</span>
        </div>
        <div class="business-card__row">
          <span class="bolder">{{ $vuetify.lang.t('$vuetify.accounting.card.sum') }}</span>
          <span>{{ parseFloat(currentMaintenance.total_net).toFixed(2) }}</span>
        </div>
        <v-divider></v-divider>
        <h3>{{ $vuetify.lang.t("$vuetify.worksAndMaterials") }}</h3>
        <div class="maintenance-grid mb-20" v-if="currentMaintenance.materials && currentMaintenance.materials.length">
          <!-- header -->
          <div class="grid-header">
            <div>{{ $vuetify.lang.t("$vuetify.codeMaterial") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.description") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.quantity") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.measurement") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.price") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.discount") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.tax") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.accounting.card.sum") }}</div>
          </div>

          <!-- body rows -->
          <div
              class="grid-row"
              v-for="(item, i) in currentMaintenance.materials"
              :key="i"
          >
            <div>{{ item.code }}</div>
            <div>{{ item.description }}</div>
            <div class="hide-mobile">{{ item.quantity }}</div>
            <div class="hide-mobile">
              {{
                (item.unit && $vuetify.lang.t("$vuetify.measurements." + item.unit))
                    ? $vuetify.lang.t("$vuetify.measurements." + item.unit)
                    : item.unit
              }}
            </div>
            <div class="hide-mobile">{{ item.cost_net }}</div>
            <div class="hide-mobile">{{ item.discount }}</div>
            <div class="hide-mobile">{{ taxes.find(t => t.id == item.tax).tax }}</div>
            <div>{{ computeLineSum(item) }}</div>
          </div>

          <!-- footer total -->
          <div class="grid-footer">
            <div class="bolder" colspan="7">{{ $vuetify.lang.t("$vuetify.accounting.statistic.count") }}</div>
            <div class="bolder">{{ computeTotalSum(currentMaintenance.materials) }}</div>
          </div>
        </div>
        <!-- Работы -->
        <div class="maintenance-grid mb-20" v-if="currentMaintenance.works && currentMaintenance.works.length">
          <!-- header -->
          <div class="grid-header">
            <div>{{ $vuetify.lang.t("$vuetify.codeWork") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.description") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.quantity") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.measurement") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.price") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.discount") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.tax") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.accounting.card.sum") }}</div>
          </div>
          <!-- rows -->
          <div class="grid-row" v-for="(item, i) in currentMaintenance.works" :key="'w'+i">
            <div>{{ item.code }}</div>
            <div>{{ item.description }}</div>
            <div class="hide-mobile">{{ item.quantity }}</div>
            <div class="hide-mobile">
              {{
                (item.unit && $vuetify.lang.t("$vuetify.measurements." + item.unit))
                    ? $vuetify.lang.t("$vuetify.measurements." + item.unit)
                    : item.unit
              }}
            </div>
            <div class="hide-mobile">{{ item.cost_net }}</div>
            <div class="hide-mobile">{{ item.discount }}</div>
            <div class="hide-mobile">{{ taxes.find(t => t.id == item.tax).tax }}</div>
            <div>{{ computeLineSum(item) }}</div>
          </div>
          <!-- footer -->
          <div class="grid-footer">
            <div class="bolder">{{ $vuetify.lang.t("$vuetify.accounting.statistic.count") }}</div>
            <div class="bolder">{{ computeTotalSum(currentMaintenance.works) }}</div>
          </div>
        </div>
        <!-- Другое -->
        <div class="maintenance-grid mb-20"
             v-if="currentMaintenance.other_items && currentMaintenance.other_items.length">
          <div class="grid-header">
            <div>{{ $vuetify.lang.t("$vuetify.other") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.description") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.quantity") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.wages.measurement") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.price") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.discount") }}</div>
            <div class="hide-mobile">{{ $vuetify.lang.t("$vuetify.accounting.card.tax") }}</div>
            <div>{{ $vuetify.lang.t("$vuetify.accounting.card.sum") }}</div>
          </div>
          <div class="grid-row" v-for="(item, i) in currentMaintenance.other_items" :key="'o'+i">
            <div>{{ item.code }}</div>
            <div>{{ item.description }}</div>
            <div class="hide-mobile">{{ item.quantity }}</div>
            <div class="hide-mobile">
              {{
                (item.unit && $vuetify.lang.t("$vuetify.measurements." + item.unit))
                    ? $vuetify.lang.t("$vuetify.measurements." + item.unit)
                    : item.unit
              }}
            </div>
            <div class="hide-mobile">{{ item.cost_net }}</div>
            <div class="hide-mobile">{{ item.discount }}</div>
            <div class="hide-mobile">{{ taxes.find(t => t.id == item.tax).tax }}</div>
            <div>{{ computeLineSum(item) }}</div>
          </div>
          <div class="grid-footer">
            <div class="bolder">{{ $vuetify.lang.t("$vuetify.accounting.statistic.count") }}</div>
            <div class="bolder">{{ computeTotalSum(currentMaintenance.other_items) }}</div>
          </div>
        </div>
      </div>
      <CoolLightBox :zIndex="99999" :useZoomBar="true" :fullScreen="true"
                    :items="lightboxMaintenanceItems"
                    :index="indexMaintenance"
                    @close="indexMaintenance = null">
      </CoolLightBox>
    </v-dialog>

    <CoolLightBox :zIndex="99999" :useZoomBar="true" :fullScreen="true"
                  :items="lightboxItems"
                  :index="index"
                  @close="index = null">
    </CoolLightBox>
    <spinner-loader v-model="loader"></spinner-loader>
  </div>
</template>

<script>
import ConfirmModal from "@/components/confirmModal.vue";
import CalendarIcon from "@/components/icons/CalendarIcon";
import {mapActions, mapGetters} from "vuex";
import CommentList from "@/components/icons/CommentList.vue";
import vuetify from "../../plugins/vuetify";
import PerPageSelect from "@/components/PerPageSelect.vue";
import BaseTable from "@/views/parts/BaseTable.vue";
import BaseCard from "@/views/parts/BaseCard.vue";
import SpinnerLoader from "@/components/SpinnerLoader.vue";

export default {
  name: "GarageView",
  components: {
    SpinnerLoader,
    BaseCard,
    BaseTable,
    PerPageSelect,
    CommentList,
    CalendarIcon,
    ConfirmModal
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      comments: [],
      profile: Number.parseInt(localStorage.getItem('user')),
      translated: [],
      show_smiles: false,

      newComment: {
        text: "",
        files: [],
        parent_comment: ""
      },

      editingFiles: [],
      deletedFiles: [],
      commentPhoto: [],
      commentPhotoRow: [],
      photoHtml: [],
      filesHtml: [],
      confirm_comment_modal: false,
      comment_to_delete: 0,
      tab_selected: 1,
      currentCar: {},
      sort: '',
      selectSorts: [
        {name: this.$vuetify.lang.t('$vuetify.sorts.byName'), value: 'name'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate'), value: 'create_date'},
      ],
      newDocument: {
        name: '',
        path: '',
        file: null
      },
      addDocumentModal: false,
      document_to_delete: 0,
      confirm_document_modal: false,
      headersDocuments: [
        {key: "name", name: 'documentName'},
        {key: "create_date", name: 'dateDownload'},
      ],
      showHeadersDocuments: {
        'name': true,
        'create_date': true,
      },

      maintenance: [],
      taxes: [],
      newMaintenance: {
        garage: null,
        odometer: null,
        tax: null,
        total_net: null,
        local_work_items: [],
        photo_file: [],
        receipt_file: [],
        attachments: []
      },
      addMaintenanceModal: false,
      maintenanceToDelete: 0,
      confirmMaintenanceModal: false,
      showMaintenanceModal: false,
      currentMaintenance: {},
      attachmentsToDelete: [],
      headersMaintenance: [
        {key: "title", name: 'documentName'},
        // {key: "dates", name: 'date'},
        // {key: "odometer", name: 'odometer'},
        // {key: "total_net", name: 'accounting.card.sum'},
      ],
      showHeadersMaintenance: {
        'title': true,
        // 'dates': true,
        // 'odometer': true,
        // 'total_net': true
      },
      menus: {
        dateStartMenu: false,
        dateEndMenu: false,
        nextDateMenu: false,
      },
      maintenanceTypes: [
        {text: this.$vuetify.lang.t('$vuetify.material'), value: 'material'},
        {text: this.$vuetify.lang.t('$vuetify.work'), value: 'work'},
        {text: this.$vuetify.lang.t('$vuetify.otherType'), value: 'other'}
      ],


      measurements: [
        'kg',
        'g',
        'm',
        'm2',
        'm3',
        'pc',
        'rll'
      ],

      type: 'cards',
      page: 1,
      perPage: Number(localStorage.getItem("per_page") ?? 24),
      length: 0,

      lightboxItems: [],
      index: null,
      lightboxMaintenanceItems: [],
      indexMaintenance: null,

      slider: "",
      alertMsg: "",
      alertError: false,
      loader: false,
      form_loader: false,

      width: screen.width,
    }
  },

  watch: {
    // как только пересчитался net, запишем его в newMaintenance.total_net
    totalGross(val) {
      this.newMaintenance.total_net = val
    },
    sort() {
      this.loadDocuments()
    },
    perPage: function () {
      if ((this.page * this.perPage) > (this.page * this.maintenance.length))
        this.page = 1
      this.loadMaintenance()
    },
  },


  created: function () {
    this.checkPermission('Гараж').then(() => {
      this.loadData();
    })
  },

  methods: {
    vuetify() {
      return vuetify
    },
    ...mapActions(['checkPermission']),


    loadData: function () {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/" + this.id,
        type: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      })
          .then((response) => {
            this.currentCar = response.data.data.data;
            this.documents = JSON.parse(this.currentCar.path)
            this.currentCar.photo = JSON.parse(this.currentCar.photo)
            this.loadMaintenance();
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    loadDocuments() {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/documents/" + this.id,
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          sort: this.sort
        }
      })
          .then((response) => {
            this.currentCar.documents = response.data.data.data
            this.currentCar.documents = this.currentCar.documents.map(d => ({
              ...d,
              options: [
                {
                  value: new Date(d.create_date).toLocaleDateString(),
                  icon: '<svg width="24" height="24" focusable="false"\n' +
                      '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                      '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n'
                },
              ]
            }))
            this.alertError = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    loadMaintenance() {

      this.$axios({
        url: this.$hostname + "time-tracking/garage/reports/",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          garage: this.id,
          sort: this.sort
        }
      }).then((response) => {
        this.maintenance = response.data.data.data
        this.maintenance = this.maintenance.map(r => ({
          ...r,
          preview: this.computePreview(r),
          dates: new Date(r.start_date).toLocaleDateString() + (r.end_date ? " - " + new Date(r.end_date).toLocaleDateString() : ""),
          options: [
            {
              value: new Date(r.start_date).toLocaleDateString() + (r.end_date ? " - " + new Date(r.end_date).toLocaleDateString() : ""),
              icon: '<svg width="24" height="24" focusable="false"\n' +
                  '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                  '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n' +
                  '              '
            },
            {
              value: r.odometer + " " + this.$vuetify.lang.t("$vuetify.km"),
              icon: '<svg width="24" height="24" focusable="false"\n' +
                  '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                  '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n' +
                  '              '
            },
            {
              value: parseFloat(r.total_net).toFixed(2), icon: '<svg width="24" height="24" focusable="false"\n' +
                  '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                  '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n' +
                  '              '
            },
          ],
        }));
        this.length = response.data.data.pages
        this.alertError = false

      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      });
    },
    computePreview(report) {
      // если есть фото процесса
      if (report.photos && report.photos.length > 0) {
        return report.photos[0].file;
      }
      // иначе, если есть чеки
      if (report.receipts && report.receipts.length > 0) {
        const firstReceipt = report.receipts[0].file;
        return firstReceipt
      }
      return "static/img/document-preview.svg";
    },

    downloadDocument(item) {
      let path = item.path
      let name = path.substr(path.lastIndexOf('/') + 1, path.lastIndexOf('_')) + path.substr(path.lastIndexOf('.'))
      this.$axios({
        url: this.$hostname + 'media/' + path,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', name);
        document.body.appendChild(fileLink);

        fileLink.click();
      })
    },
    addDocument() {
      this.newDocument.name = this.newDocument.name ? this.newDocument.name : this.newDocument.file.name
      this.$axios({
        url: this.$hostname + "time-tracking/garage/documents/" + this.id,
        method: "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDocument,
      })
          .then(() => {
            this.loadData();
            this.newDocument = {
              name: '',
              path: '',
              file: null,
            }
            this.addDocumentModal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).then(() => {
        this.form_loader = false
      })
    },
    putDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/documents/" + this.id,
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDocument,
      })
          .then(() => {
            this.loadData();
            this.newDocument = {
              name: '',
              path: '',
              file: null,
            }
            this.addDocumentModal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).then(() => {
        this.form_loader = false
      })
    },
    deleteDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/documents/" + this.id,
        method: "DELETE",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.document_to_delete
        },
      })
          .then(() => {
            this.loadData();
            this.confirm_document_modal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    uploadDocumentFiles() {
      if (this.$refs.documentForm.validate()) {
        this.form_loader = true
        if (this.newDocument.file) {
          this.$axios({
            url: this.$hostname + "time-tracking/images/upload/" + "garage",
            method: "POST",
            headers: {
              Authorization:
                  "Token " +
                  (localStorage.getItem("auth_token") ||
                      sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
            data: {
              file: this.newDocument.file,
            },
          })
              .then((response) => {
                this.newDocument.path = response.data.data
                if (this.newDocument.id)
                  this.putDocument()
                else
                  this.addDocument()
              })
              .catch((error) => {
                alert("Ошибка загрузки файла: " + this.$catch(error));
              });
        } else {
          this.putDocument()
        }
      } else {
        this.alertMsg = "Заполните обязательные поля"
        this.alertError = true
      }
    },
    confirm_document_open(id) {
      this.confirm_document_modal = true;
      this.alertError = false
      this.document_to_delete = id;
    },
    cancelAddDocument() {
      this.newDocument = {
        name: '',
        path: [],
        file: null
      };
      this.addDocumentModal = false;
    },

    openMaintenanceModal(m = undefined) {
      this.loader = true
      // загрузка налогов
      this.$axios({
        url: this.$hostname + "time-tracking/accounting/taxes",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.taxes = response.data.data.data
        this.addMaintenanceModal = true
        if (m) {
          let tmp2 = JSON.parse(JSON.stringify(m)) // для правильной работы реактивности в редактировании
          tmp2.local_work_items = tmp2.works.concat(tmp2.materials).concat(tmp2.other_items)
          tmp2.receipt_file = []
          tmp2.photo_file = []
          this.newMaintenance = tmp2
        } else {
          this.newMaintenance = {
            garage: this.id,
            odometer: null,
            tax: null,
            total_net: null,
            local_work_items: [],
            attachments: [],
            photo_file: [],
            receipt_file: [],
          }
        }
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).finally(() => {
        this.loader = false
      });
    },
    confirmMaintenance(m) {
      this.confirmMaintenanceModal = true
      this.maintenanceToDelete = m.id
    },
    addWorkItem() {
      this.newMaintenance.local_work_items.push({
        type: '',
        code: '',
        description: '',
        quantity: 1,
        unit: '',
        tax: null,
        discount: 0,
        cost_net: 0
      })
      this.$forceUpdate()
    },
    removeWorkItem(i) {
      this.newMaintenance.local_work_items.splice(i, 1)
    },
    removeAttachment(doc, type, i) {
      this.attachmentsToDelete.push(doc)
      if (type == "photo")
        this.newMaintenance.photos.splice(i, 1)
      if (type == "receipt")
        this.newMaintenance.receipts.splice(i, 1)
    },
    cancelAddMaintenance() {
      this.addMaintenanceModal = false
      this.newMaintenance = {
        garage: null,
        odometer: null,
        tax: null,
        total_net: null,
        local_work_items: [],
        work_items: [],
        attachments: [],
        photo_file: [],
        receipt_file: [],
      }
      this.attachmentsToDelete = [];
    },
    async uploadMaintenanceDocuments() {
      if (!this.$refs.maintenanceForm.validate()) {
        this.alertMsg = "Заполните обязательные поля";
        this.alertError = true;
        return;
      }

      this.form_loader = true;
      this.alertError = false;
      this.newMaintenance.attachments = [];

      const uploadPromises = [];

      this.newMaintenance.photo_file.forEach(ph => {
        const p = this.uploadFile(ph)
            .then(response => {
              let path = response.data.data
              this.newMaintenance.attachments.push({file: path, type: 'photo'});
            }).catch((error) => {
              alert("Ошибка загрузки файла: " + error.message);
            });

        uploadPromises.push(p);
      });

      this.newMaintenance.receipt_file.forEach(r => {
        const p = this.uploadFile(r)
            .then(response => {
              let path = response.data.data
              this.newMaintenance.attachments.push({file: path, type: 'receipt'});
            }).catch((error) => {
              alert("Ошибка загрузки файла: " + error.message);
            });
        uploadPromises.push(p);
      });
      try {
        await Promise.all(uploadPromises)
            .then(() => {
              this.addMaintenance();
            })
            .catch((error) => {
              console.error("Error during file upload:", error);
            });
      } catch (err) {
        console.error(err);
        this.alertMsg = "Ошибка при загрузке файлов";
        this.alertError = true;
      } finally {
        this.form_loader = false;
      }
    },
    uploadFile(file) {
      return this.$axios({
        url: this.$hostname + "time-tracking/images/upload/" + "garage",
        method: "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
    },
    addMaintenance() {
      this.newMaintenance.attachments = JSON.stringify(this.newMaintenance.attachments)
      this.newMaintenance.work_items = JSON.stringify(this.newMaintenance.local_work_items)
      this.newMaintenance.attachments_to_delete = JSON.stringify(this.attachmentsToDelete)
      this.$axios({
        url: this.$hostname + "time-tracking/garage/reports/" + (this.newMaintenance.id ? this.newMaintenance.id + "/" : ""),
        method: this.newMaintenance.id ? "PUT" : "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newMaintenance,
      }).then(() => {
        this.loadMaintenance();
        this.cancelAddMaintenance()
      }).catch((response) => {
        this.alertMsg = this.$catch(response);
        this.alertError = true;
      }).then(() => {
        this.form_loader = false
      })
    },
    deleteMaintenance() {
      this.$axios({
        url: this.$hostname + "time-tracking/garage/reports/" + this.maintenanceToDelete + "/",
        method: "DELETE",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.maintenanceToDelete
        },
      })
          .then(() => {
            this.loadMaintenance();
            this.confirmMaintenanceModal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    showMaintenance(m) {
      this.loader = true
      // загрузка налогов
      this.$axios({
        url: this.$hostname + "time-tracking/accounting/taxes",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.taxes = response.data.data.data
        this.currentMaintenance = m;
        this.lightboxMaintenanceItems = []
        m.photos.forEach(p => {
          if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(p.file.substr(p.file.lastIndexOf('.') + 1))) {
            this.lightboxMaintenanceItems.push(this.$media_url + p.file)
          } else {
            this.lightboxMaintenanceItems.push(this.$hostname + 'time-tracking/preview/' + p.file)
          }
        })
        m.receipts.forEach(p => {
          if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(p.file.substr(p.file.lastIndexOf('.') + 1))) {
            this.lightboxMaintenanceItems.push(this.$media_url + p.file)
          } else {
            this.lightboxMaintenanceItems.push(this.$hostname + 'time-tracking/preview/' + p.file)
          }
        })
        this.showMaintenanceModal = true;
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).finally(() => {
        this.loader = false
      });
    },

    computeLineSum(item) {
      const qty = parseFloat(item.quantity) || 0;
      const cost = parseFloat(item.cost_net) || 0;
      const discount = parseFloat(item.discount) || 0;
      const taxRate = parseFloat(item.tax ? this.taxes.find(t => t.id === item.tax).tax : 0) || 0;
      // сумма без НДС после скидки
      const net = cost * qty * (1 - discount / 100);
      // сумма НДС
      const tax = net * (taxRate / 100);
      // итог
      return (net + tax).toFixed(2);
    },

    // пробегает по массиву items и складывает computeLineSum для каждого
    computeTotalSum(items) {
      if (items)
        return items.reduce((sum, item) => {
          return sum + parseFloat(this.computeLineSum(item));
        }, 0)
            .toFixed(2);
      else return 0
    },

    all() {
      this.perPage = undefined
      this.loadData()
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    calculatedWorkItems() {
      return this.newMaintenance.local_work_items.map(item => {
        const qty = parseFloat(item.quantity) || 0
        const cost = parseFloat(item.cost_net) || 0
        const disc = parseFloat(item.discount) || 0
        console.log(item.tax)
        const taxRate = item.tax ? this.taxes.find(t => t.id === item.tax).tax : 0

        // чистая сумма после скидки
        const netAfterDiscount = cost * qty * (1 - disc / 100)
        // сумма НДС по этому элементу
        const taxAmount = netAfterDiscount * (taxRate / 100)
        // итог с НДС
        const gross = netAfterDiscount + taxAmount

        return {
          ...item,
          netAfterDiscount: netAfterDiscount.toFixed(2),
          taxAmount: taxAmount.toFixed(2),
          gross: gross.toFixed(2)
        }
      })
    },
    // общая сумма без НДС по всем элементам
    totalNet() {
      return this.calculatedWorkItems
          .reduce((sum, i) => sum + parseFloat(i.netAfterDiscount), 0)
          .toFixed(2)
    },
    // общая сумма НДС
    totalTax() {
      return this.calculatedWorkItems
          .reduce((sum, i) => sum + parseFloat(i.taxAmount), 0)
          .toFixed(2)
    },
    // общая сумма с НДС
    totalGross() {
      return this.calculatedWorkItems
          .reduce((sum, i) => sum + parseFloat(i.gross), 0)
          .toFixed(2)
    },
  }
}
</script>

<style scoped>
</style>